
export default {
  props: {
    status: {
      type: String,
      required: true
    }
  },
  computed: {
    color() {
      switch (this.status) {
        case 'uploaded':
          return 'gray'
        case 'processing':
          return 'blue'
        case 'processed':
          return 'success'
        case 'failed-processing':
          return 'error'
        default:
          return 'gray'
      }
    }
  }
}
